import{Locale as n}from"../../../locale/Locale.enum.mjs";const a={hasAdmin:new Map([[n.ja,"あり"],[n.en,"Has Admin"]]),notAdmin:new Map([[n.ja,"なし"],[n.en,"Not Admin"]])};export{a as systemAdminCheckNameConfig};
